export const EWUS_INITIALIZE = '/api/Ewus/Initialize';
export const EWUS_VERIFICATION = '/api/Ewus';
export const CREDENTIALS = '/api/Ewus/Credentials';